import React, { useState } from "react";
import Box from "@mui/material/Box";
import {
  DataGrid,
  gridClasses,
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const AllRFQBidTable = ({ rfqs, activeTab, isLoading, storedUser }) => {
  const navigate = useNavigate();
  
  const handleCheck = (id) => {
    navigate(`/dashboard/${id}`);
  };

  const columns = [
    {
      field: "rfqId",
      headerName: "RFQ ID",
      flex: 1,
      renderCell: (params) => (
        <span
          className="table-title"
          onClick={() => handleCheck(params.row.rfqId)}
        >
          {params.row.rfqId}
        </span>
      ),
    },
    {
      field: "shortDesc",
      headerName: "Short Description",
      flex: 1,
    },
    {
      field: "name",
      headerName: "Requisitioner Name",
      flex: 1,
    },
    {
      field: "dept",
      headerName: "Requisitioner Dept.",
      flex: 1,
    },
    {
      field: "submissionDate",
      headerName: "Submission Date",
      flex: 1,
      renderCell: (params) => {
        const { rebidEndDate, submissionDate } = params.row;
        return formatDateTime(rebidEndDate || submissionDate);
      },
    },
    {
      field: "bidStatus",
      headerName: "Quote Status",
      flex: 1.5,
      renderCell: (params) => {
          const statusColors = {
          SUBMITTED: "#35D85B",
          APPROVED_1: "#009688",
          APPROVED_2: "#BEB3B3",
          APPROVED: "#35D85B",
          AWARDED: "#0381F3",
          REJECTED: "#CB856B",
          EAUCTIONED: "#FF9800",
          REBID: "#FF9800",
          ACCEPTING_BIDS: "#009688",
          BIDS_CLOSED: "#BEB3B3",
        };

        const statusLabels = {
          SUBMITTED: "In Review by Buyer",
          APPROVED_1: "Approved by Buyer",
          APPROVED_2: "Approved by Purchase Manager",
          APPROVED: "Approved by Final Approver 1",
          AWARDED: "Awarded",
          REJECTED: "Rejected",
          EAUCTIONED: "Sent for E-Auction",
          REBID: "Revised",
          ACCEPTING_BIDS: "Accepting Quotes",
          BIDS_CLOSED: "Quotes Closed",
        };
        return (
          <span
            style={{
              background: statusColors[params.row.bidStatus],
              borderRadius: "15px",
              padding: "5px 15px",
              fontWeight: 600,
            }}
          >
            {statusLabels[params.row.bidStatus]}
          </span>
        );
      },
    },
    {
        field: "action",
        headerName: "Action",
        flex: 1.2,
        renderCell: (params) => (
          params.row.status !== "EAUCTIONED" &&
            <Button
              className="btn-contained"
              sx={{
                margin: "0 !important",
                fontSize: "12px",
                px: 9,
                width: "0 !important",
              }}
              onClick={() => navigate(`/dashboard/view-bid-data/${params.row.rfqId}`)}
            >
              View Quotes
            </Button>
        ),
      },
  ];

  const formatDateTime = (dateString) => {
    if (!dateString) return "";
    const [date, time] = dateString.split("T");
    const [year, month, day] = date.split("-");
    const cleanTime = time?.split(".")[0];
    return `${day}/${month}/${year} ${cleanTime}`;
  };


  const rows =
    rfqs &&
    rfqs.map((rfq) => ({
      ...rfq,
      creationDate: formatDateTime(rfq.creationDate),
      // submissionDate: formatDateTime(rfq.submissionDate),
    }));

  return (
    <Box sx={{ width: "100%", minHeight: "400px" }}>
      <DataGrid
        rows={rows}
        columns={columns}
        loading={isLoading}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        pageSizeOptions={[10]}
        disableRowSelectionOnClick
        disableColumnSelector
        disableDensitySelector
        disableColumnMenu
        disableColumnResize
        slots={{ toolbar: CustomToolbar }}
        getRowId={(row) => row.rfqId}
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
        }
        sx={{
          position: "relative",
          border: "none",
          fontFamily: "Inter !important",

          "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: "700 !important",
          },
          "& .MuiDataGrid-columnHeaders": {
            background: "none !important",
            color: "black",
            fontSize: "14px",
            borderRadius: "10px",
          },
          "& .MuiDataGrid-row:hover": {
            backgroundColor: "#fff",
          },
          "& .MuiDataGrid-cell": {
            fontSize: "13px",
            border: "none",
          },
          "& .MuiDataGrid-columnSeparator": {
            display: "none",
          },
          "& .css-1ccsd5i-MuiButtonBase-root-MuiButton-root": {
            color: "#000 !important",
            border: "1px solid #B0B0B0",
            borderRadius: "12px",
            padding: 1,
          },
          "& .MuiInputBase-root-MuiInput-root::after": {
            borderBottom: "none !important",
          },
          "& .MuiInputBase-root-MuiInput-root": {
            borderBottom: "none !important",
          },
          [`& .${gridClasses.row}.even`]: {
            backgroundColor: "#EAF4FF",
            // '&:hover': {
            //   backgroundColor: "#f6f6f6",
            // },
          },
          "& .MuiInput-underline:before": {
            borderBottom: "none !important",
          },
          "& .css-5h82ro-MuiInputBase-root-MuiInput-root::after": {
            borderBottom: "none !important",
          },
        }}
      />
    </Box>
  );
};

export default AllRFQBidTable;

function CustomToolbar() {
  return (
    <GridToolbarContainer sx={{ display: "flex", justifyContent: "end" }}>
      <GridToolbarQuickFilter
        sx={{
          border: "1px solid #B0B0B0",
          borderRadius: "12px",
          padding: "4px 12px",
          "&:hover": {
            backgroundColor: "#D8E9F0",
          },
          "& .MuiInputBase-root": {
            borderRadius: "12px",
          },
          width: 300,
        }}
      />
      {/* <GridToolbarFilterButton /> */}
    </GridToolbarContainer>
  );
}